module.exports = __webpack_public_path__ + "static/media/volleyball.3c82d4db.svg";